import { MockedRequest, RequestHandler, restContext, setupWorker } from 'msw';
/* eslint-disable-next-line import/no-unresolved */
import { SetupWorkerApi } from 'msw/lib/types/setupWorker/setupWorker';
import {
  userApiHandlers,
  accountApiHandlers,
  resourceCategoryHandlers,
  resourceSubcategoryHandlers,
  tokenHandlers,
  messageApiHandlers,
} from './handlers';
import EnvironmentVariables from '../context/Environment/EnvironmentVariables';

const configureWorker = ({
  MOCK_USER,
  MOCK_ACCOUNT,
  MOCK_RESOURCES,
  MOCK_EVE_OAUTH2_TOKEN,
  MOCK_MESSAGES,
}: EnvironmentVariables): SetupWorkerApi => {
  let handlers: RequestHandler<MockedRequest, typeof restContext>[] = [];

  if (MOCK_USER === true) {
    handlers = handlers.concat(userApiHandlers);
  }

  if (MOCK_ACCOUNT === true) {
    handlers = handlers.concat(accountApiHandlers);
  }

  if (MOCK_RESOURCES === true) {
    handlers = handlers.concat(resourceCategoryHandlers, resourceSubcategoryHandlers);
  }

  if (MOCK_EVE_OAUTH2_TOKEN === true) {
    handlers = handlers.concat(tokenHandlers);
  }

  if (MOCK_MESSAGES === true) {
    handlers = handlers.concat(messageApiHandlers);
  }

  const worker = setupWorker(...handlers);
  return worker;
};

export default configureWorker;
